import RazorPayInfo from './razorpay-info';

export default RazorPayInfo;
